module.exports = __webpack_public_path__ + "static/img/96_phase_function_Paper_Points.4f21825.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/96_phase_function_Paper_Points.png
// module id = 3ZuR
// module chunks = 0